import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Select } from '@etherisc/ui-kit';
import { apiClient } from '../../services/api';
import type { Client } from '../../types/Insurance';

interface ClientSelectProps {
  label: string;
  value?: string;
  onChange: (clientId: string) => void;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
}

export const ClientSelect: React.FC<ClientSelectProps> = ({ 
  label, 
  value, 
  onChange, 
  placeholder = "Select client...",
  disabled = false,
  required = false
}) => {
  const { data: clients, isLoading, error } = useQuery({
    queryKey: ['clients'],
    queryFn: (): Promise<Client[]> => apiClient.getClients(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false
  });

  if (error) {
    console.error('Failed to load clients:', error);
  }

  const options = [
    { value: 'none', label: placeholder },
    ...(clients?.map(client => ({
      value: client.id,
      label: `${client.name} (${client.code})`
    })) || [])
  ];

  return (
    <Select 
      label={label}
      value={value || 'none'}
      onValueChange={(val) => onChange(val === 'none' ? '' : val)}
      disabled={disabled || isLoading}
      required={required}
      options={options}
    />
  );
};
